<script setup>
import { ref, watch, defineProps, defineEmits } from "vue";

const props = defineProps({
  topic: { type: String, required: true },
  cancelTrigger: { type: Boolean, default: false },
});

const emit = defineEmits(["search", "cancel"]);

const typed = ref("");
const searched = ref("");

const cancel = () => {
  typed.value = "";
  searched.value = "";
  emit("cancel");
};

watch(
  () => props.cancelTrigger,
  (value) => {
    if (value === true) cancel();
  }
);

const search = () => {
  const value = typed.value.trim();
  if (!value) return;
  searched.value = value;
  emit("search", { topic: props.topic, search: value });
};
</script>

<template>
  <div
    v-if="searched"
    class="flex items-center justify-between gap-3 rounded-xl bg-accent/10 px-3.5 py-2 text-sm"
  >
    <span class="min-w-0 truncate">
      <span class="text-secondary dark:text-night-muted">{{ topic }}:</span>
      <span class="font-semibold">{{ searched }}</span>
    </span>
    <button type="button" class="btn-quiet -my-1 px-2.5 py-1.5" @click="cancel">
      <font-awesome-icon icon="xmark" />
      Clear
    </button>
  </div>
  <form v-else class="flex gap-2" @submit.prevent="search">
    <label :for="`search-${topic}`" class="sr-only"
      >Search by {{ topic }}</label
    >
    <input
      :id="`search-${topic}`"
      v-model="typed"
      class="field"
      type="search"
      :placeholder="`Search by ${topic.toLowerCase()}`"
    />
    <button
      type="submit"
      class="btn-primary shrink-0"
      :disabled="!typed.trim()"
    >
      Search
    </button>
  </form>
</template>
